import { HEAREN_STATES } from '@/matrix/hearenstates';
import { HEAREN_TRIGGERS } from '@/matrix/hearentriggers';
import { HEAREN_MATRIX_SCENARIOS } from '@/matrix/hearenmatrixscenarios';
import { resolveHearenUserStep } from '@/matrix/hearenusersteps';

// ======================================================
// HEAREN MATRIX ENGINE V1
// Silent guidance & continuity engine
// ======================================================

// ======================================================
// REAL USER SIGNALS ONLY
// No forced scenario in production
// ======================================================

const DEBUG_MATRIX_SCENARIO = null;

const getSignals = (realSignals = {}) => {
  if (
    DEBUG_MATRIX_SCENARIO &&
    HEAREN_MATRIX_SCENARIOS[DEBUG_MATRIX_SCENARIO]
  ) {
    return HEAREN_MATRIX_SCENARIOS[DEBUG_MATRIX_SCENARIO];
  }

  return realSignals || {};
};

export const resolveHearenState = (realSignals = {}) => {
  const signals = getSignals(realSignals);
  const userStep = resolveHearenUserStep(signals);

  const {
    sessionsCount = 0,
    totalMinutes = 0,
    currentSessionMinutes = 0,
    testsCompleted = false,
    currentHour = 12,
    lowInteraction = false,
  } = signals;

  // ======================================================
  // DEEP IMMERSION
  // Long stable session → matrix becomes silent
  // ======================================================

  if (
    currentSessionMinutes >=
      HEAREN_TRIGGERS.DEEP_IMMERSION.longSessionMinutes &&
    lowInteraction
  ) {
    const state = HEAREN_STATES.DEEP_IMMERSION;

    console.log('[HEAREN MATRIX]', {
      scenario: DEBUG_MATRIX_SCENARIO || 'real_user_signals',
      selectedState: state.id,
      userStep,
      suggestion: state.suggestion,
    });

    return {
      ...state,
      userStep,
    };
  }


  // ======================================================
  // PROFILE READY
  // Tests/profile completed → user can simply listen
  // ======================================================

  if (testsCompleted) {
    const state = HEAREN_STATES.PROFILE_READY;

    console.log('[HEAREN MATRIX]', {
      scenario: DEBUG_MATRIX_SCENARIO || 'real_user_signals',
      selectedState: state.id,
      suggestion: state.suggestion,
    });

    return {
      ...state,
      userStep,
    };
  }

  
  // ======================================================
  // READY FOR DEEPER
  // User trusts Hearen enough for tests/progression
  // ======================================================

  if (
    sessionsCount >=
      HEAREN_TRIGGERS.READY_FOR_DEEPER.minimumSessions
  ) {
    const state = HEAREN_STATES.READY_FOR_DEEPER;

    console.log('[HEAREN MATRIX]', {
      scenario: DEBUG_MATRIX_SCENARIO || 'real_user_signals',
      selectedState: state.id,
      suggestion: state.suggestion,
    });

    return {
      ...state,
      userStep,
    };
  }

  // ======================================================
  // EVENING RETURN
  // Ritualized evening usage
  // ======================================================

  if (
    HEAREN_TRIGGERS.EVENING_RETURN.preferredHours.includes(currentHour) &&
    sessionsCount >=
      HEAREN_TRIGGERS.EVENING_RETURN.minimumSessions
  ) {
    const state = HEAREN_STATES.EVENING_RETURN;

    console.log('[HEAREN MATRIX]', {
      scenario: DEBUG_MATRIX_SCENARIO || 'real_user_signals',
      selectedState: state.id,
      suggestion: state.suggestion,
    });

    return {
      ...state,
      userStep,
    };
  }

  // ======================================================
  // DISCOVERY
  // Early usage phase
  // ======================================================

  if (sessionsCount === 0) {
    const state = HEAREN_STATES.DISCOVERY;

    console.log('[HEAREN MATRIX]', {
      scenario: DEBUG_MATRIX_SCENARIO || 'real_user_signals',
      selectedState: state.id,
      suggestion: state.suggestion,
    });

    return {
      ...state,
      userStep,
    };
  }

  // ======================================================
  // FALLBACK
  // ======================================================

  const fallback = HEAREN_STATES.FATIGUE_SOFTENING;

  console.log('[HEAREN MATRIX]', {
    scenario: DEBUG_MATRIX_SCENARIO || 'real_user_signals',
    selectedState: fallback.id,
    suggestion: fallback.suggestion,
  });

  return {
    ...fallback,
    userStep,
  };
};